import { Component } from '@angular/core';
import { FullscreenLoaderService } from '@app/services';

@Component({
  selector: 'app-fullscreen-loader',
  templateUrl: './fullscreen-loader.component.html',
  styleUrls: ['./fullscreen-loader.component.scss'],
  providers: [],
})
export class FullScreenLoaderComponent {
  loading: boolean = false;

  constructor(private fullScreenLoaderService: FullscreenLoaderService) {}

  ngOnInit() {
    this.fullScreenLoaderService.isopen$.subscribe((res) => {
      this.loading = res;
    });
  }
}
